import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { QuickAppointmentContext } from '../Context';
import { formatPrice } from '../helper';

const CostPreview = ({
  subtotalDollars,
  shopFee,
  salesTaxRate,
  salesTaxAmountDollars,
  minimumServiceChargeAmountDollars,
  couponAmount,
  totalAmountDollars,
}) => {
  const { couponCode, customDiscountAmount } = useContext(
    QuickAppointmentContext,
  );

  return (
    <>
      <Box mt={2.7} ml={1} mb={0.8}>
        <Typography variant="h6">Cost Preview</Typography>
      </Box>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2}>Subtotal</TableCell>
            <TableCell align="right">{formatPrice(subtotalDollars)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Shop Fee</TableCell>
            <TableCell align="right">{formatPrice(shopFee)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Sales Tax - {salesTaxRate}%</TableCell>
            <TableCell align="right">
              {formatPrice(salesTaxAmountDollars)}
            </TableCell>
          </TableRow>
          {!!minimumServiceChargeAmountDollars && (
            <TableRow>
              <TableCell colSpan={2}>Minimum Service Charge</TableCell>
              <TableCell align="right">
                {formatPrice(minimumServiceChargeAmountDollars)}
              </TableCell>
            </TableRow>
          )}
          {(!!couponCode || !!couponAmount) && (
            <TableRow>
              <TableCell colSpan={2}>Coupon {couponCode}</TableCell>
              <TableCell align="right">- {formatPrice(couponAmount)}</TableCell>
            </TableRow>
          )}
          {!!customDiscountAmount && (
            <TableRow>
              <TableCell colSpan={2}>Custom Discount</TableCell>
              <TableCell align="right">
                - {formatPrice(customDiscountAmount)}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell colSpan={2}>
              <strong>Total</strong>
            </TableCell>
            <TableCell align="right">
              <strong>{formatPrice(totalAmountDollars)}</strong>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default CostPreview;
